export default __webpack_public_path__ + "static/media/news2402293.baf28112.jpg";